<template>
  <div>
    <input
      ref="resumeUpload"
      type="file"
      name="expert[resume]"
      @change="selectFile"
      class="mb-1"
    >
    <b-spinner
      v-if="uploading || deleting"
      variant="info"
      small
    />
    <b-button
      variant="success"
      size="sm"
      :disabled="uploading"
      @click="doUpload"
    >
      Upload Resume
    </b-button>

    <div
      v-if="resumePath !== null && resumePath !== ''"
      class="d-inline-block"
    >
      <b-link
        :href="resumePath"
        target="_blank"
        class="btn btn-info btn-sm"
      >
        View Resume
      </b-link>
      <b-button
        variant="danger"
        size="sm"
        :disabled="deleting"
        @click="deleteResume"
      >
        <i class="fa fa-fw fa-times" />
      </b-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'ExpertResumeUpload',
    props: {
        expertId: {
            type: Number,
            required: true,
        },
        expertResume: {
            type: String,
            default: null,
        },
    },
    data: function () {
        return {
            resume: null,
            resumePath: this.expertResume,
            uploading: false,
            deleting: false,
        }
    },
    watch: {
        expertResume: function () {
            this.resumePath = this.expertResume
        },
    },
    methods: {
        selectFile (event) {
            this.resume = event.target.files[0]
        },
        async doUpload () {
            if (this.resume === null) {
                alert('Please select resume file')
                return false
            }

            const data = new FormData()
            data.append('resume', this.resume)

            try {
                this.uploading = true
                const uploadResult = (await axios.post(`/admin/experts/${this.expertId}/upload-resume`, data)).data
                this.resumePath = uploadResult.success.data.uploadedFile
                this.uploading = false
                this.$refs.resumeUpload.value = null
                this.resume = null

                await this.$bvModal.msgBoxOk(uploadResult.success.data.message)

                await this.$store.commit('expert/updateExpertResume',
                    { expertId: this.expertId, resume_url: this.resumePath })
            } catch (error) {
                this.uploading = false
                if (error.response.status !== 200) {
                    if (error.response.status === 413) {
                        alert('File size is too large')
                    } else {
                        alert(error.response.data.errors.resume[0])
                    }
                }
            }
        },
        deleteResume(){
            this.$bvModal.msgBoxConfirm('Are you sure to delete this resume?').then(value => {
                if (value) {
                    this.doDelete()
                }
            }).catch(err => {
                console.dir(err)
            })
        },
        async doDelete () {
            try {
                this.deleting = true

                const result = (await axios.post(`/admin/experts/${this.expertId}/delete-resume`, {
                    'expert-id': this.expertId,
                })).data

                await this.$bvModal.msgBoxOk(result.success.data.message)

                this.deleting = false
                this.resumePath = null
                await this.$store.commit('expert/updateExpertResume',
                    { expertId: this.expertId, resume_url: this.resumePath })
            } catch (error) {
                this.deleting = false
                alert(error.response.data.errors.resume[0])
            }
        },
    },
}
</script>
